

























import { Component, Vue } from 'vue-property-decorator'
import { navBarLocalisationKeys } from '@/features/navBar/navBar.localisation'
import { JOB_LIST_NAME } from '@/features/job/job.router'

@Component
export default class HomeConfirmationDialog extends Vue {
  private translations = navBarLocalisationKeys
  private showDialog: boolean = false

  public openDialog (): void {
    this.showDialog = true
  }

  private handleConfirm (): void {
    this.$router.push({ name: JOB_LIST_NAME })
  }
}
